/* Zenith Builds V8.9.7 — lightweight, persistent theme choice with smooth transition. */
(() => {
  'use strict';
  const root = document.documentElement;
  const key = 'zenithTheme';
  let timer = 0;
  const readMode = () => root.dataset.zenithTheme === 'dark' ? 'dark' : 'light';
  const isEnglish = () => root.dataset.zenithLang === 'en';
  const syncControls = () => {
    const dark = readMode() === 'dark';
    const label = dark ? (isEnglish() ? 'Switch to light mode' : 'Activează modul luminos')
                       : (isEnglish() ? 'Switch to dark mode' : 'Activează modul întunecat');
    const visibleLabel = dark ? (isEnglish() ? 'Light mode' : 'Mod luminos')
                              : (isEnglish() ? 'Dark mode' : 'Mod întunecat');
    document.querySelectorAll('[data-zenith-theme-toggle]').forEach(button => {
      button.setAttribute('aria-label', label);
      button.setAttribute('title', label);
      button.setAttribute('aria-pressed', String(dark));
      const span = button.querySelector('[data-zenith-theme-label]');
      if (span) span.textContent = visibleLabel;
    });
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.content = dark ? '#0a0a0b' : '#f7f7f5';
  };
  const runTransition = () => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    window.clearTimeout(timer);
    root.classList.add('is-theme-switching');
    timer = window.setTimeout(() => root.classList.remove('is-theme-switching'), 430);
  };
  const setMode = mode => {
    const next = mode === 'dark' ? 'dark' : 'light';
    runTransition();
    root.dataset.zenithTheme = next;
    try { localStorage.setItem(key, next); } catch (_) {}
    syncControls();
  };
  document.addEventListener('click', event => {
    const toggle = event.target.closest?.('[data-zenith-theme-toggle]');
    if (!toggle) return;
    setMode(readMode() === 'dark' ? 'light' : 'dark');
  });
  document.addEventListener('zenith:languagechange', syncControls);
  window.addEventListener('storage', event => {
    if (event.key === key) {
      root.dataset.zenithTheme = event.newValue === 'dark' ? 'dark' : 'light';
      syncControls();
    }
  });
  const onReady = () => {
    root.classList.add('zenith-theme-ready');
    syncControls();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, {once:true});
  else onReady();
})();
